<script lang="ts">
    import {api} from "../../../../../services/api/reallis"
    import u from 'src/components/main/home/components/home-elements/u.svg'
    import element1 from 'src/components/main/home/components/home-elements/element1.png'
    import element2 from 'src/components/main/home/components/home-elements/element2.png'
    import element3 from 'src/components/main/home/components/home-elements/element3.png'
    import person from 'src/components/main/home/components/home-elements/person.png'
    import audienceBackground from 'src/components/main/home/components/home-elements/audience.png'
    import games from 'src/components/main/home/components/home-elements/games.png'
    import world from 'src/components/main/home/components/home-elements/world.jpg'

    let audience = getAudience()

    async function getAudience() {
        let result = await api.ws.ws1.request({
            data: {
                agent: "user",
                auth: {type: "webSite"},
                lang: "en",
                method: "profile_getNum",
                params: {}
            }
        })
        return (result.result.response.value - result.result.response.value % 1000).toLocaleString()
    }
</script>

<section class="home-elements" style="--World:url({world});">
    <div class="container">
        <div class="row">
            <div class="col-md-2 d-none d-sm-block">
                <img src="{u}" class="u" alt="">
            </div>
            <div class="col-md-10">
                <div class="title">Our Features And <br><span>Uniqueness</span></div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-3"></div>
            <div class="col-md-6">
                <div class="description">We make unique exciting games in which players can earn money while having fun, doing what they love. We strive to grow and develop, expand the audience and increase the number of games for our players.</div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-3"></div>
            <div class="col-md-9">
                <div class="row">
                    <div class="col-md-4">
                        <div class="figure figure-1">
                            <img src="{element1}" alt="">
                        </div>
                        <div class="name">Gaming</div>
                        <div class="caption">We create games with the integration of blockchain, Defi and NFT components.</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="person">
            <img src="{person}" alt="">
        </div>
    </div>
    <div class="blur"></div>
    <div class="lines-wrapper notranslate">
        <div class="white-line">
            <div class="marquee__content">
                <span>Elemental Games</span>
                <span>Elemental Games</span>
                <span>Elemental Games</span>
                <span>Elemental Games</span>
                <span>Elemental Games</span>
                <span>Elemental Games</span>
                <span>Elemental Games</span>
                <span>Elemental Games</span>
                <span>Elemental Games</span>
                <span>Elemental Games</span>
                <span>Elemental Games</span>
                <span>Elemental Games</span>
                <span>Elemental Games</span>
                <span>Elemental Games</span>
                <span>Elemental Games</span>
                <span>Elemental Games</span>
                <span>Elemental Games</span>
                <span>Elemental Games</span>
                <span>Elemental Games</span>
                <span>Elemental Games</span>
                <span>Elemental Games</span>
                <span>Elemental Games</span>
                <span>Elemental Games</span>
                <span>Elemental Games</span>
                <span>Elemental Games</span>
                <span>Elemental Games</span>
                <span>Elemental Games</span>
                <span>Elemental Games</span>
                <span>Elemental Games</span>
                <span>Elemental Games</span>
                <span>Elemental Games</span>
                <span>Elemental Games</span>
                <span>Elemental Games</span>
                <span>Elemental Games</span>
                <span>Elemental Games</span>
                <span>Elemental Games</span>
                <span>Elemental Games</span>
                <span>Elemental Games</span>
                <span>Elemental Games</span>
                <span>Elemental Games</span>
                <span>Elemental Games</span>
                <span>Elemental Games</span>
                <span>Elemental Games</span>
                <span>Elemental Games</span>
                <span>Elemental Games</span>
                <span>Elemental Games</span>
                <span>Elemental Games</span>
                <span>Elemental Games</span>
                <span>Elemental Games</span>
                <span>Elemental Games</span>
                <span>Elemental Games</span>
                <span>Elemental Games</span>
                <span>Elemental Games</span>
                <span>Elemental Games</span>
                <span>Elemental Games</span>
                <span>Elemental Games</span>
                <span>Elemental Games</span>
                <span>Elemental Games</span>
                <span>Elemental Games</span>
                <span>Elemental Games</span>
            </div>
        </div>
        <div class="orange-line">
            <div class="marquee__content">
                <span>Elemental Games</span>
                <span>Elemental Games</span>
                <span>Elemental Games</span>
                <span>Elemental Games</span>
                <span>Elemental Games</span>
                <span>Elemental Games</span>
                <span>Elemental Games</span>
                <span>Elemental Games</span>
                <span>Elemental Games</span>
                <span>Elemental Games</span>
                <span>Elemental Games</span>
                <span>Elemental Games</span>
                <span>Elemental Games</span>
                <span>Elemental Games</span>
                <span>Elemental Games</span>
                <span>Elemental Games</span>
                <span>Elemental Games</span>
                <span>Elemental Games</span>
                <span>Elemental Games</span>
                <span>Elemental Games</span>
                <span>Elemental Games</span>
                <span>Elemental Games</span>
                <span>Elemental Games</span>
                <span>Elemental Games</span>
                <span>Elemental Games</span>
                <span>Elemental Games</span>
                <span>Elemental Games</span>
                <span>Elemental Games</span>
                <span>Elemental Games</span>
                <span>Elemental Games</span>
                <span>Elemental Games</span>
                <span>Elemental Games</span>
                <span>Elemental Games</span>
                <span>Elemental Games</span>
                <span>Elemental Games</span>
                <span>Elemental Games</span>
                <span>Elemental Games</span>
                <span>Elemental Games</span>
                <span>Elemental Games</span>
                <span>Elemental Games</span>
                <span>Elemental Games</span>
                <span>Elemental Games</span>
                <span>Elemental Games</span>
                <span>Elemental Games</span>
                <span>Elemental Games</span>
                <span>Elemental Games</span>
                <span>Elemental Games</span>
                <span>Elemental Games</span>
                <span>Elemental Games</span>
                <span>Elemental Games</span>
                <span>Elemental Games</span>
                <span>Elemental Games</span>
                <span>Elemental Games</span>
                <span>Elemental Games</span>
                <span>Elemental Games</span>
                <span>Elemental Games</span>
                <span>Elemental Games</span>
                <span>Elemental Games</span>
                <span>Elemental Games</span>
                <span>Elemental Games</span>
            </div>
        </div>
    </div>
    <div class="container">
        <div class="row">
            <div class="col-lg-7">
                <div class="audience" style="--AudienceBackground:url({audienceBackground});">
                    <div class="audience-gradient">
                        <div class="audience-text">Our audience is already more than</div>
                        {#await audience}
                            <span class="loading audience-loading"></span>
                        {:then count}
                            <div class="audience-value">{count}+</div>
                        {/await}
                    </div>
                </div>
            </div>
            <div class="col-lg-5">
                <img src="{games}" class="games" alt="">
            </div>
        </div>
    </div>
</section>

<style>
    .home-elements {
        padding-bottom: 70px;
    }

    .u {
        margin-top: 150px;
        position: absolute;
    }

    .title {
        font-family: 'Anton', sans-serif;
        font-size: 70px;
        font-weight: 400;
        color: white;
        margin: 0 0 30px;
        line-height: 90px;
        text-transform: uppercase;
        letter-spacing: 0.02em;
    }

    .title span {
        color: transparent;
        -webkit-text-stroke: 1px white;
    }

    .description {
        font-size: 18px;
        line-height: 27px;
        color: white;
        margin: 0 0 100px;
    }

    .figure {
        background: #1A1C25;
        border-radius: 10px;
        position: relative;
        width: 100px;
        height: 100px;
    }

    .figure img {
        margin: -10px 0 0 20px;
    }

    .figure-1:before {
        content: "";
        position: absolute;
        background: #3cdbc0;
        opacity: 0.7;
        width: 40px;
        height: 40px;
        top: 50%;
        left: 50%;
        margin: -20px 0 0 -20px;
        filter: blur(30px);
        border-radius: 10px;
    }

    .figure-2:before {
        content: "";
        position: absolute;
        background: #BB6BD9;
        opacity: 0.7;
        width: 40px;
        height: 40px;
        top: 50%;
        left: 50%;
        margin: -20px 0 0 -20px;
        filter: blur(30px);
        border-radius: 10px;
    }

    .figure-3:before {
        content: "";
        position: absolute;
        background: #F2C94C;
        opacity: 0.7;
        width: 40px;
        height: 40px;
        top: 50%;
        left: 50%;
        margin: -20px 0 0 -20px;
        filter: blur(30px);
        border-radius: 10px;
    }

    .name {
        font-size: 30px;
        line-height: 30px;
        color: white;
        margin: 40px 0 15px;
        text-transform: uppercase;
        font-family: 'Anton', sans-serif;
    }

    .caption {
        font-size: 16px;
        line-height: 24px;
        color: #BDBDBD;
        font-weight: 300;
        padding-right: 20px;
    }

    .person {
        margin: 150px 0 0;
        text-align: center;
        position: relative;
        z-index: 2;
    }

    .lines-wrapper {
        overflow: hidden;
        height: 360px;
        padding-top: 200px;
        margin-top: -200px;
    }

    .white-line {
        width: calc(100% + 30px);
        background: white;
        height: 90px;
        font-size: 40px;
        color: #01070A;
        line-height: 40px;
        padding: 26px 0;
        margin-left: -15px;
        font-family: 'Anton', sans-serif;
        letter-spacing: 2px;
        overflow: hidden;
        text-transform: uppercase;
        transform: rotate(5deg);
        margin-top: -80px;
        position: relative;
        z-index: 3;
    }

    .orange-line {
        width: calc(100% + 30px);
        background: #3cdbc0;
        height: 90px;
        font-size: 40px;
        color: white;
        line-height: 40px;
        padding: 26px 0;
        margin-left: -15px;
        font-family: 'Anton', sans-serif;
        letter-spacing: 2px;
        overflow: hidden;
        text-transform: uppercase;
        transform: rotate(-5deg);
        margin-top: -70px;
        position: relative;
        z-index: 3;
    }

    .white-line .marquee__content {
        display: flex;
        padding-left: 0;
        -webkit-animation: marquee 20s infinite linear;
        animation: marquee 20s infinite linear;
    }

    .orange-line .marquee__content {
        display: flex;
        padding-right: 100%;
        -webkit-animation: marquee-right 20s infinite linear;
        animation: marquee-right 20s infinite linear;
    }

    .marquee__content span {
        padding: 0 40px;
        white-space: nowrap;
    }

    .white-line .marquee__content span:nth-child(odd) {
        color: white;
        -webkit-text-stroke: 1px #01070A;
    }

    .orange-line .marquee__content span:nth-child(odd) {
        color: #3cdbc0;
        -webkit-text-stroke: 1px #01070A;
    }

    .container {
        position: relative;
        z-index: 2;
    }

    @-webkit-keyframes marquee {
        0%{-webkit-transform: translate(0, 0);}
        100%{-webkit-transform: translate(-100%, 0);}
    }

    @keyframes marquee {
        0%{transform: translate(0, 0);}
        100%{transform: translate(-100%, 0)}
    }

    @-webkit-keyframes marquee-right {
        0%{-webkit-transform: translate(-100%, 0);}
        100%{-webkit-transform: translate(0, 0);}
    }

    @keyframes marquee-right {
        0%{transform: translate(-100%, 0);}
        100%{transform: translate(0, 0)}
    }

    .blur {
        background: linear-gradient(55deg,rgba(221, 84, 136, 0.9) 0, rgba(63, 51, 227, 0.4) 60%);
        width: 40vw;
        height: 50vw;
        position: absolute;
        transform: translateY(-103%);
        left: -250px;
        filter: blur(150px);
        opacity: 0.3;
    }

    .audience {
        background: var(--AudienceBackground) no-repeat center;
        height: 364px;
        width: 100%;
        text-align: center;
        position: relative;
        margin-top: 160px;
    }

    .audience-gradient {
        content: "";
        background: linear-gradient(90deg, rgba(23, 27, 35, 0.3) 0%, rgba(45, 49, 59, 0.3) 100%);
        width: 100%;
        height: 100%;
        padding: 77px 0;
        position: absolute;
        left: 0;
        top: 0;
    }

    .audience-text {
        font-size: 30px;
        color: white;
        font-family: 'Anton', sans-serif;
        line-height: normal;
        text-transform: uppercase;
        position: relative;
        z-index: 2;
    }

    .audience-value {
        font-size: 120px;
        color: #3cdbc0;
        font-family: 'Anton', sans-serif;
        line-height: normal;
        position: relative;
        z-index: 2;
    }

    .audience:before {
        display: block;
        content: '';
        position: absolute;
        border: 2px solid white;
        border-right-color: transparent;
        border-bottom-color: transparent;
        width: 20px;
        height: 20px;
        top: 0;
        left: 0;
        z-index: 2;
    }

    .audience:after {
        display: block;
        content: '';
        position: absolute;
        border: 2px solid white;
        border-right-color: transparent;
        border-top-color: transparent;
        width: 20px;
        height: 20px;
        bottom: 0;
        left: 0;
        z-index: 2;
    }

    .games {
        margin: 90px auto 0;
        display: block;
    }

    .home-elements {
        background: var(--World) no-repeat right bottom;
    }

    @media(max-width: 1199px) {
        .title {
            font-size: 50px;
            line-height: 70px;
        }

        .name {
            font-size: 26px;
            line-height: 26px;
        }

        .games {
            max-width: 100%;
        }
    }

    @media(max-width: 991px) {
        .person img {
            width: 550px;
        }

        .name {
            font-size: 22px;
            line-height: 22px;
        }

        .orange-line {
            height: 70px;
            font-size: 30px;
            line-height: 40px;
            padding: 15px 0;
        }

        .white-line {
            height: 70px;
            font-size: 30px;
            line-height: 40px;
            padding: 15px 0;
        }

        .person {
            margin: 50px 0 0;
        }

        .audience {
            margin-top: 0;
            background-size: cover;
            height: 260px;
        }

        .audience-gradient {
            padding: 50px 0;
        }

        .audience-value {
            font-size: 90px;
        }

        .home-elements {
            margin-top: 50px;
            padding-bottom: 100px;
        }

        .caption {
            font-size: 14px;
            line-height: 19px;
        }
    }

    @media(max-width: 767px) {
        .title {
            font-size: 40px;
            line-height: 52px;
            margin-bottom: 20px;
        }

        .home-elements {
            margin-top: 20px;
            padding-bottom: 50px;
        }

        .description {
            font-size: 14px;
            line-height: 21px;
            margin: 0 0 60px;
        }

        .name {
            font-size: 30px;
            line-height: 30px;
            margin: 25px 0 10px;
        }

        .caption {
            font-size: 13px;
            line-height: 19px;
            color: #A0AEC0;
            margin: 10px 0 50px;
        }

        .person img {
            width: calc(100% + 70px);
            margin-right: -70px;
        }

        .person {
            margin: 50px -12px 0;
            overflow: hidden;
        }

        .orange-line {
            height: 44px;
            font-size: 20px;
            line-height: 30px;
            padding: 8px 0;
            margin-top: -40px;
            transform: rotate(-6deg);
        }

        .white-line {
            height: 44px;
            font-size: 20px;
            line-height: 30px;
            padding: 8px 0;
            margin-top: -50px;
            transform: rotate(6deg);
        }

        .audience {
            height: 230px;
        }

        .audience-gradient {
            padding: 40px 0;
        }

        .audience-text {
            font-size: 20px;
            margin-bottom: 20px;
        }

        .audience-value {
            font-size: 60px;
            line-height: 105px;
        }

        .games {
            max-width: 100%;
            margin: 30px auto 0;
        }
    }
</style>
